import { render, staticRenderFns } from "./ActionAsReply.vue?vue&type=template&id=5e21616f&scoped=true&"
import script from "./ActionAsReply.vue?vue&type=script&lang=ts&"
export * from "./ActionAsReply.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e21616f",
  null
  
)

export default component.exports